// extracted by mini-css-extract-plugin
export var cell = "index-module--cell--AxuBy";
export var cellContainer = "index-module--cellContainer--TkgjM";
export var container = "index-module--container--ZJchn";
export var description = "index-module--description--DT9Ia";
export var grid = "index-module--grid--Fa4W2";
export var image = "index-module--image--KlhlV";
export var infoContainer = "index-module--infoContainer--57sGL";
export var lightWrapper = "index-module--lightWrapper--qDbOF";
export var slider = "index-module--slider--LQCFY";
export var tag = "index-module--tag--5XIit";